import React from 'react';
// import blackShoe from "../../../assets/icons/blackshoe.svg";
// import shoeIcon from "../../../assets/icons/shoe.svg";
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { GiStrikingArrows } from "react-icons/gi";
import { GiSoccerBall } from "react-icons/gi";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { IoIosCloseCircle } from "react-icons/io";
import { GiBurningRoundShot } from "react-icons/gi";
import { GiHeavyRain } from "react-icons/gi";
import { GiLightningTrio } from "react-icons/gi";





const Card = ({ data }) => {
    const { t, i18n } = useTranslation();

    return (
        <div className={`flex flex-col h-max my-2 font-breeSerif rounded-2xl text-sm shadow-lg border-2 transition-all duration-300 ${data?.status === "Win" ? 'bg-gradient-to-r from-green-50/95 via-white/98 to-green-50/95 border-green-500/40 hover:border-green-500/60' : 'bg-gradient-to-r from-red-50/95 via-white/98 to-red-50/95 border-crimson/40 hover:border-crimson/60'} backdrop-blur-xl hover:shadow-xl`}>
            <div className='px-4 py-3 rounded-t-2xl'>
                <div className='flex items-center justify-between'>
                    <div className='flex items-center gap-2'>
                        <div className={`w-8 h-8 rounded-lg flex items-center justify-center shadow-md border ${data?.status === "Win" ? 'bg-gradient-to-br from-green-500 via-green-600 to-green-500 border-green-400/40' : 'bg-gradient-to-br from-crimson via-red-primary to-crimson border-golden/40'}`}>
                            {data.gamblingTypeId === 2 && <GiHeavyRain size={16} className="text-white" />}
                            {data.gamblingTypeId === 1 && <GiSoccerBall size={16} className="text-white" />}
                        </div>
                        <h2 className='font-bold text-blue-primary'>{data?.gamblingTypeId === 1 ? t("body") : t("maungg")}</h2>
                    </div>
                    <div className="text-right">
                        <p className="text-xs font-semibold text-blue-primary font-breeSerif">
                            {moment(new Date(data?.createdDate)).format('DD.MM.YYYY')}
                        </p>
                        <p className="text-xs text-blue-primary font-breeSerif">
                            {moment(new Date(data?.createdDate)).format('h:mm A')}
                        </p>
                    </div>
                </div>
            </div>

            <div className='px-5 space-y-2'>
                <div className='grid grid-cols-2 gap-4 py-2 border pl-9 bg-white/80 rounded-xl border-crimson/20'>
                    <h4 className='font-bold text-blue-primary'>{t("betAmount")}</h4>
                    <p className='font-semibold font-breeSerif text-blue-primary'>{parseInt(data?.amount).toLocaleString()}</p>
                </div>
                {
                    data?.gamblingTypeId === 2 ?
                        <div className='grid grid-cols-2 gap-4 py-2 border pl-9 bg-white/80 rounded-xl border-crimson/20'>
                            <h4 className='font-bold text-blue-primary'>{t("teamCount")}</h4>
                            <p className='font-semibold font-breeSerif text-blue-primary'>{data?.teamCount}</p>
                        </div>
                        : null
                }
                <div className='grid grid-cols-2 gap-4 py-2 border pl-9 bg-white/80 rounded-xl border-crimson/20'>
                    <h4 className='font-bold text-blue-primary'>{t("profitAmount")}</h4>
                    <p className='font-semibold font-breeSerif text-blue-primary'>{data?.profitAmount < 0 ? "0" : parseInt(data?.profitAmount).toLocaleString()}</p>
                </div>
            </div>

            <div className={`flex justify-end tracking-wider px-5 py-3 mt-2 rounded-b-2xl relative overflow-hidden ${data?.status === `Win` ? 'bg-green-500/10' : 'bg-red-500/10'}`}>
                {/* Luxury Border Accent at top */}
                <div className={`absolute top-0 left-0 right-0 h-1 ${data?.status === `Win` ? 'bg-gradient-to-r from-green-500 via-green-400 to-green-500' : 'bg-gradient-to-r from-crimson via-golden to-crimson'} shadow-lg`}></div>
                <p className='font-extrabold mr-4 flex items-center gap-1.5'>
                    {
                        data.status === `Win` ? <IoIosCheckmarkCircle size={20} className='text-win' /> : <IoIosCloseCircle size={20} className='text-lose' />
                    }
                    <span className={data?.status === `Win` ? 'text-win' : 'text-lose'}>{data?.status}</span>
                </p>
            </div>
        </div>
    );
};

export default Card;
